// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Dropdown-DropdownDivider-module--cls1--2aedW","cls2":"Dropdown-DropdownDivider-module--cls2--lS4II Dropdown-DropdownDivider-module--cls1--2aedW"};